(() => {
  if (window.BelantaraTapBrief) return;

  const singaporeDate = value => {
    const parts = new Intl.DateTimeFormat('en', {
      timeZone: 'Asia/Singapore',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(value || new Date());
    const part = type => parts.find(item => item.type === type)?.value || '';
    return `${part('year')}-${part('month')}-${part('day')}`;
  };

  const displayCode = value => String(value || '')
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, character => character.toUpperCase());

  const payload = (context = {}) => {
    const visitDate = singaporeDate(new Date());
    const eventCode = String(context.event_code || '').trim();
    const venueCode = String(context.venue_code || '').trim();

    if (
      !eventCode ||
      !venueCode ||
      eventCode.toLowerCase() === 'generic' ||
      venueCode.toLowerCase() === 'generic'
    ) {
      return null;
    }

    return {
      profile: {
        tap_visit_date: visitDate,
        tap_visit_event_code: eventCode,
        tap_visit_event_name: displayCode(eventCode),
        tap_visit_venue_code: venueCode,
        tap_visit_venue_name: displayCode(venueCode)
      },
      event: {
        visit_date: visitDate,
        visit_event_code: eventCode,
        visit_venue_code: venueCode
      }
    };
  };

  window.BelantaraTapBrief = Object.freeze({
    payload,
    singaporeDate
  });
})();
